import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
import routes from "~routes"; // eslint-disable-next-line import/no-extraneous-dependencies

import { MoonIcon } from "@chakra-ui/icons";
import { Button, HStack, useColorMode, useColorModeValue } from "@chakra-ui/react";
import Link from "next/link";
import { useRouter } from "next/router";
var routeArray = Object.entries(routes);

var Navbar = function Navbar() {
  var router = useRouter();

  var _useColorMode = useColorMode(),
      toggleColorMode = _useColorMode.toggleColorMode;

  var isRoute = React.useCallback(function (route) {
    return router.route == route;
  }, [router.route]);
  var bgColor = useColorModeValue("rgba(255, 255, 255, 0.6)", "rgba(23, 25, 35, 0.6)");
  var color = useColorModeValue("#000", "#fff");
  var borderBottomColor = useColorModeValue("#ff069a47", "whiteAlpha.50");
  var colorScheme = useColorModeValue("pink", "yellow");
  return /*#__PURE__*/_jsxs(HStack, {
    bgColor: bgColor,
    borderBottomColor: borderBottomColor,
    borderBottomWidth: "2px",
    color: color,
    d: ["none", "flex"],
    insetX: 0,
    justify: "center",
    p: [2, 4],
    pos: "sticky",
    sx: {
      "@supports (backdrop-filter: blur(12px))": {
        backdropFilter: "blur(12px)",
        bgColor: bgColor
      },
      "@supports (-webkit-backdrop-filter: blur(12px))": {
        WebkitBackdropFilter: "blur(12px)",
        bgColor: bgColor
      }
    },
    top: 0,
    zIndex: "modal",
    children: [routeArray.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          route = _ref2[0],
          name = _ref2[1];

      return /*#__PURE__*/_jsx(Link, {
        href: route,
        passHref: true,
        children: /*#__PURE__*/_jsx(Button, {
          as: "a",
          colorScheme: isRoute(route) ? colorScheme : undefined,
          fontWeight: isRoute(route) ? "bold" : "normal",
          variant: "ghost",
          children: name
        })
      }, name);
    }), /*#__PURE__*/_jsx(MoonIcon, {
      onClick: toggleColorMode
    })]
  });
};

export default Navbar;